import { UPDATE_CHAT_TIMESTAMP } from '../types/chat';

export const updateChatTimestamp = () => ({
  type: UPDATE_CHAT_TIMESTAMP,
});
